/* global grecaptcha */

import { Controller } from 'stimulus';
import porta from 'porta';
import nl from 'porta/src/i18n/nl';
import toArray from '../helpers/toArray';

class FormValidationController extends Controller {
  connect() {
    porta({
      target: this.element,
      messages: nl,
      onValidate: (formElement) => {
        this.disableSubmitButton(formElement);
      },
      onError: (formElement) => {
        this.enableSubmitButton(formElement);
      },
      onValid: (formElement) => {
        this.enableSubmitButton(formElement);

        const recaptcha = formElement.querySelector('.js-g-recaptcha');

        if (recaptcha) {
          grecaptcha.execute(recaptcha.getAttribute('data-widget-id'));
          return false;
        }

        return true;
      },
    });
  }

  disableSubmitButton(formElement) {
    this.toggleSubmitButtonState(formElement, false);
  }

  enableSubmitButton(formElement) {
    this.toggleSubmitButtonState(formElement, true);
  }

  // eslint-disable-next-line
  toggleSubmitButtonState(formElement, state) {
    toArray(formElement.querySelectorAll('[type="submit"]')).forEach((button) => {
      button[state ? 'removeAttribute' : 'setAttribute']('disabled', 'disabled');
    });
  }
}

export default FormValidationController;
